import { TypePriority } from '../../interfaces'
import {
  GET_TYPE_PRIORITY,
  GET_TYPE_PRIORITY_EXITO
} from '../types/typePriorityActionsTypes'

export type TypePriorityAction = TypesPriorityAction | TypesPriorityActionAsync

// Acción síncrona: guarda en Redux los typePriorities o el error
export interface TypesPriorityAction {
  type: typeof GET_TYPE_PRIORITY_EXITO
  typesPriority: TypePriority[] | undefined
  error: string | undefined
}

export const getTypesPriorityAction = (
  typesPriority?: TypePriority[],
  error?: string
): TypesPriorityAction => ({
  type: GET_TYPE_PRIORITY_EXITO,
  typesPriority,
  error
})

// Acción para disparar la saga
export interface TypesPriorityActionAsync {
  type: typeof GET_TYPE_PRIORITY
}

export const getTypesPriorityActionAsync = (): TypesPriorityActionAsync => ({
  type: GET_TYPE_PRIORITY
})
